import React from "react";
import PropTypes from "prop-types";
import { RadioButton } from "../../../components/RadioButton";

/**
 * Board view chooser.
 * Whether if App View, Bulletin view, Calendar view or Strict Collections View.
 * @param {BoardView.propTypes} props
 */
export const BoardView = (props) => {
	const viewModes = [
		{
			value: "AI",
			label: "App View",
			description:
				"Full bulletin board with apps, collections, and hoots.",
		},
		{
			value: "BB",
			label: "Bulletin View",
			description: "Simple bulletin board view without apps.",
		},
		{
			value: "CV",
			label: "Calendar View",
			description: "Event calendar view to showcase your events.",
		},
		{
			value: "SC",
			label: "Strict Collections View",
			description:
				"Restricted view with hoots from selected collections only.",
		},
	];

	// onChange handler for view mode.
	const onCheck = (item) => {
		const newValue = {
			...props.value,
			view: item.value,
		};
		// reset the collections if CV is selected
		if (item.value === "CV") {
			newValue.collections = [];
		}
		props.onChange(newValue);
	};

	return (
		<div className="mb-8">
			<div className="font-bold mb-1">Embedded Board View</div>
			<div className="text-sm leading-5 mb-1">
				Choose the content shown as part of the HootBoard plugin embed.
			</div>
			<div className="flex flex-wrap">
				{viewModes.map((item, index) => (
					<div className="flex w-1/2 mt-4" key={index}>
						<RadioButton
							color="plugin-3"
							isChecked={item.value === props.value.view}
							onCheck={() => onCheck(item)}
						/>
						<div className="text-sm ml-2 -mt-1">
							<div className="font-bold">{item.label}</div>
							<div className="mt-1">{item.description}</div>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

BoardView.propTypes = {
	value: PropTypes.object.isRequired,
	onChange: PropTypes.func.isRequired,
};
